(() => {
  if (window.pcdCollectionNav) return;
  window.pcdCollectionNav = true;

  // In de theme editor wel sticky en dropdown, maar geen AJAX-navigatie
  const designMode = Boolean(window.Shopify?.designMode);

  const LINK_SELECTOR = '.pcd-ch__pill[href], .pcd-ch__tile[href], .pcd-ch__switch-link[href], .pcd-ch__sheet-chip[href], .pcd-cn__banner[href]';
  let controller = null;
  const locationKey = () => window.location.pathname + window.location.search;
  let currentKey = locationKey();

  // Alle templatesecties (apps zoals wishlist wrappen ze, dus geen directe children)
  const getSectionIds = () =>
    [...document.querySelectorAll('#MainContent .shopify-section[id^="shopify-section-template--"]')]
      .map((el) => el.id.replace('shopify-section-', ''));

  // ?view=pcd meenemen zolang het template nog niet aan collecties hangt
  const buildUrl = (href) => {
    const url = new URL(href, window.location.origin);
    const view = new URLSearchParams(window.location.search).get('view');
    if (view && !url.searchParams.has('view')) url.searchParams.set('view', view);
    return url;
  };

  const centerActivePill = () => {
    const pills = document.querySelector('.pcd-ch__pills');
    const active = pills?.querySelector('.pcd-ch__pill.is-active');
    if (!pills || !active) return;
    pills.scrollLeft = active.offsetLeft - (pills.clientWidth - active.offsetWidth) / 2;
  };

  const setSwitchOpen = (open) => {
    const toggle = document.querySelector('[data-pcd-switch-toggle]');
    const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  };

  // Banner onderaan op een subfilter: volgende pill uit de balk, na de laatste de volgende collectie
  const updateNextBanner = () => {
    const sub = document.querySelector('[data-pcd-cn-sub]');
    if (!sub) return;
    const main = document.querySelector('[data-pcd-cn-main]');

    let next = document.querySelector('.pcd-ch__pills .pcd-ch__pill.is-active')?.nextElementSibling;
    while (next && !next.matches('.pcd-ch__pill')) next = next.nextElementSibling;

    sub.hidden = !next;
    if (main) main.hidden = Boolean(next);
    if (!next) return;

    const title = next.textContent.trim();
    const label = sub.querySelector('[data-pcd-cn-sub-label]');
    sub.setAttribute('href', next.getAttribute('href'));
    sub.querySelector('[data-pcd-cn-sub-title]').textContent = title;
    if (label) label.textContent = `${label.dataset.prefix} ${title}`.trim();
  };

  // Filterpaneel mobiel: open-status op <html> zodat hij een herrender in de editor overleeft
  const isSheetOpen = () => document.documentElement.classList.contains('pcd-ch-sheet-open');

  const setSheetOpen = (open, { instant = false } = {}) => {
    const sheet = document.querySelector('[data-pcd-sheet]');
    const toggle = document.querySelector('[data-pcd-sheet-toggle]');
    if (!sheet) return;
    const wasOpen = sheet.classList.contains('is-open');

    sheet.classList.toggle('is-instant', instant);
    sheet.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('pcd-ch-sheet-open', open);
    toggle?.setAttribute('aria-expanded', String(open));
    if (instant) requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.remove('is-instant')));

    if (open && !wasOpen) {
      setSwitchOpen(false);
      sheet.querySelector('.pcd-ch__sheet-panel')?.focus({ preventScroll: true });
    } else if (!open && wasOpen && sheet.contains(document.activeElement)) {
      toggle?.focus({ preventScroll: true });
    }
  };

  // Pillenbalk vastzetten onder de header zodra je er voorbij scrollt
  const updateStuck = () => {
    const bar = document.querySelector('[data-pcd-bar]');
    if (!bar) return;

    const header = document.querySelector('.section-header');
    const promo = document.querySelector('.announcement-bar-promo-container');
    const limit = Math.max(header?.getBoundingClientRect().bottom || 0, promo?.getBoundingClientRect().bottom || 0);
    const stuck = bar.getBoundingClientRect().top < limit - 1;

    // Top live meten i.p.v. --header-height, die na scrollen niet meer bijgewerkt wordt
    if (stuck) bar.style.setProperty('--pcd-ch-bar-top', `${limit}px`);
    else bar.style.removeProperty('--pcd-ch-bar-top');
    if (stuck === bar.classList.contains('is-stuck')) return;

    // Hoogte vasthouden zodat de pagina niet verspringt als de balk fixed wordt
    bar.style.height = stuck ? `${bar.offsetHeight}px` : '';
    bar.classList.toggle('is-stuck', stuck);
    if (!stuck) setSwitchOpen(false);
  };

  let stuckFrame = null;
  const onScroll = () => {
    if (stuckFrame) return;
    stuckFrame = requestAnimationFrame(() => {
      stuckFrame = null;
      updateStuck();
    });
  };

  // Laadknop: volgende pagina onder het grid plakken
  let loadingMore = false;

  const loadMore = async (button) => {
    const grid = document.querySelector('[data-pcd-grid]');
    if (!grid || loadingMore) return;

    loadingMore = true;
    button.classList.add('is-loading');
    const fetchUrl = buildUrl(button.getAttribute('href'));
    fetchUrl.searchParams.set('section_id', grid.dataset.sectionId);

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error(response.status);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');

      html.querySelectorAll('[data-pcd-grid] > li').forEach((item) => grid.append(item));

      const shown = document.querySelector('[data-pcd-shown]');
      if (shown) shown.textContent = grid.querySelectorAll('.pcd-grid__item').length;

      const next = html.querySelector('[data-pcd-more]');
      if (next) button.setAttribute('href', next.getAttribute('href'));
      else document.querySelector('[data-pcd-more-wrap]')?.remove();
    } catch (error) {
      window.location.href = buildUrl(button.getAttribute('href')).href;
    } finally {
      loadingMore = false;
      button.classList.remove('is-loading');
    }
  };

  const render = async (url, { push, toTop = false }) => {
    const sectionIds = getSectionIds();

    controller?.abort();
    controller = new AbortController();
    const { signal } = controller;
    document.documentElement.classList.add('pcd-ch-loading');

    // Per sectie via section_id: ?sections= geeft null terug in combinatie met ?view=
    const fetchSection = async (id) => {
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', id);
      const response = await fetch(fetchUrl, { signal });
      if (!response.ok) throw new Error(response.status);
      return response.text();
    };

    try {
      const sections = await Promise.all(sectionIds.map(fetchSection));

      // Ander template of ontbrekende sectie: gewoon doorladen
      if (sections.some((section) => !section)) {
        window.location.href = url.href;
        return;
      }

      sectionIds.forEach((id, index) => {
        const html = new DOMParser().parseFromString(sections[index], 'text/html');
        const fresh = html.getElementById(`shopify-section-${id}`);
        const current = document.getElementById(`shopify-section-${id}`);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });

      const header = document.querySelector('.pcd-ch');
      if (header?.dataset.pageTitle) document.title = header.dataset.pageTitle;
      if (push) history.pushState({ pcd: true }, '', url.href);
      currentKey = locationKey();

      centerActivePill();
      updateStuck();
      updateNextBanner();

      // Banner onderaan: naar het begin van de nieuwe collectie
      if (toTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // Alleen terugscrollen als de pills buiten beeld of vastgezet zijn; scroll-margin houdt rekening met de header
      const bar = document.querySelector('[data-pcd-bar]');
      if (bar && (bar.classList.contains('is-stuck') || bar.getBoundingClientRect().top < 0)) {
        bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.href = url.href;
    } finally {
      document.documentElement.classList.remove('pcd-ch-loading');
    }
  };

  document.addEventListener('click', (event) => {
    const moreButton = event.target.closest('[data-pcd-more]');
    if (moreButton && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      loadMore(moreButton);
      return;
    }

    const switchToggle = event.target.closest('[data-pcd-switch-toggle]');
    if (switchToggle) {
      setSwitchOpen(switchToggle.getAttribute('aria-expanded') !== 'true');
      return;
    }
    if (!event.target.closest('.pcd-ch__switch-panel')) setSwitchOpen(false);

    if (event.target.closest('[data-pcd-sheet-toggle]')) {
      setSheetOpen(true);
      return;
    }
    if (event.target.closest('[data-pcd-sheet-close]')) {
      setSheetOpen(false);
      return;
    }

    const link = event.target.closest(LINK_SELECTOR);
    // Keuze in het filterpaneel: paneel sluiten, de nieuwe producten laden erachter
    if (link?.closest('[data-pcd-sheet]')) setSheetOpen(false);
    if (designMode || !link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    const url = buildUrl(link.getAttribute('href'));
    if (url.origin !== window.location.origin) return;

    event.preventDefault();
    if (url.href === window.location.href) return;
    render(url, { push: true, toTop: link.classList.contains('pcd-cn__banner') });
  });

  window.addEventListener('popstate', () => {
    // Alleen een hash-wijziging (zoals #MainContent) hoeft niet te renderen
    if (designMode || locationKey() === currentKey) return;
    render(new URL(window.location.href), { push: false });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setSwitchOpen(false);
    if (isSheetOpen()) setSheetOpen(false);
  });

  // Header schuift of krimpt (trustbalk) met een transitie: balk elk frame laten meelopen
  let followUntil = 0;
  const followHeader = () => {
    const running = performance.now() < followUntil;
    followUntil = performance.now() + 400;
    if (running) return;
    const step = () => {
      updateStuck();
      if (performance.now() < followUntil) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  document.querySelector('.section-header')?.addEventListener('transitionrun', followHeader);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // Theme editor rendert een sectie opnieuw na elke wijziging: vastzetten direct herstellen
  document.addEventListener('shopify:section:load', () => {
    centerActivePill();
    updateStuck();
    updateNextBanner();
    if (isSheetOpen()) setSheetOpen(true, { instant: true });
  });

  centerActivePill();
  updateStuck();
  updateNextBanner();
})();
